import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import "./community.css";

/* ==========================================================
   CATEGORY CONFIG — AI-READY, CLEAN, CONSISTENT
   ========================================================== */

const CATEGORY_MAP = [
  { id: "All", label: "All" },
  { id: "resume-reviews", label: "Resume Writing" },
  { id: "interview-tips", label: "Interview Prep" },
  { id: "salary-transparency", label: "Salary Negotiation" },
  { id: "strategies", label: "Job Search Tips" },
  { id: "career-growth", label: "Career Growth" },
  { id: "success-stories", label: "Success Stories" },
];

/* ==========================================================
   FORUM COMPONENT
   ========================================================== */

function Forum() {
  const [posts, setPosts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState("All");

  /* ==========================================================
     🔵 LOAD ALL FORUM POSTS
     ========================================================== */
  useEffect(() => {
    async function fetchPosts() {
      try {
        const q = query(
          collection(db, "community_posts"),
          orderBy("createdAt", "desc")
        );

        const snap = await getDocs(q);

        const list = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        setPosts(list);
        setFiltered(list);
      } catch (err) {
        console.error("Forum load error:", err);
      }

      setLoading(false);
    }

    fetchPosts();
  }, []);

  /* ==========================================================
     🔍 FILTER BY CATEGORY (AI-READY)
     ========================================================== */
  const filterByCategory = (catId) => {
    setActiveFilter(catId);

    if (catId === "All") {
      setFiltered(posts);
      return;
    }

    const filteredList = posts.filter((p) => p.category === catId);
    setFiltered(filteredList);
  };

  /* ==========================================================
     UI — CLEAN + RESPONSIVE + AI FUTURE-PROOF
     ========================================================== */

  return (
    <div className="forum-wrapper">
      <h1 className="forum-title">📝 Career Forums</h1>
      <p className="forum-subtitle">
        Ask questions, get career help, and share your experience.
      </p>

      {/* CATEGORY FILTER CHIPS */}
      <div className="forum-categories">
        {CATEGORY_MAP.map((cat) => (
          <span
            key={cat.id}
            className={`category-chip ${
              activeFilter === cat.id ? "chip-active" : ""
            }`}
            onClick={() => filterByCategory(cat.id)}
          >
            {cat.label}
          </span>
        ))}
      </div>

      {/* CREATE NEW POST BUTTON */}
      <div className="new-post-container">
        <Link to="/community/new-post" className="new-post-btn">
          + Create New Post
        </Link>
      </div>

      {/* POSTS LIST */}
      {loading ? (
        <div className="forum-loading">Loading posts...</div>
      ) : filtered.length === 0 ? (
        <p className="no-posts">No posts under this category.</p>
      ) : (
        <div className="forum-posts">
          {filtered.map((post) => (
            <Link to={`/community/thread/${post.id}`} key={post.id} className="forum-card">
              <h3 className="forum-card-title">{post.title}</h3>

              <p className="forum-card-body">
                {post.body.length > 160
                  ? post.body.substring(0, 160) + "..."
                  : post.body}
              </p>

              <div className="forum-meta">
                <span className="forum-category-tag">
                  {CATEGORY_MAP.find((c) => c.id === post.category)?.label ||
                    post.category}
                </span>
                <span>{new Date(post.createdAt).toLocaleDateString()}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default Forum;

